import { ViewModel } from '../interfaces/ViewModel';
import { action, makeObservable, observable, set } from 'mobx';
import { makeMetadata, property } from '../helpers/decorators';

export class BaseVM extends ViewModel {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  /**
   * 设置当前元素是否可见
   * @example
   *    vm.visible = false
   *    vm.visible = true
   */
  @property @observable visible: boolean = undefined;

  /**
   * 更新当前元素可见性
   * @param visible {boolean}
   */
  @action setVisible(visible: boolean): this {
    this.visible = visible;
    return this;
  }

  /**
   * 更新当前VM的state信息
   */
  @observable state: Record<string, any> = {};

  /**
   * 设置当前VM的state信息
   * @param state
   */
  @action setState(state: any): this {
    set(this.state, state);
    return this;
  }
}
